import enumConstants from './../enumConstants.json'
import { MODEL_TYPE } from './model_types.jsx'

export const BANK_STATEMENT_LINE_SOURCE_TYPE_TO_MODEL_TYPE = {
  [enumConstants.bank_statement_line_source_types.SALES_INVOICE]: MODEL_TYPE.SALES_INVOICE,
  [enumConstants.bank_statement_line_source_types.SALES_CREDIT_MEMO]: MODEL_TYPE.SALES_CREDIT_MEMO,
  [enumConstants.bank_statement_line_source_types.SALES_FINANCE_CHARGE]: MODEL_TYPE.SALES_FINANCE_CHARGE,
  [enumConstants.bank_statement_line_source_types.SALES_ADVANCE_INVOICE]: MODEL_TYPE.SALES_ADVANCE_INVOICE,
  [enumConstants.bank_statement_line_source_types.SALES_ORDER]: MODEL_TYPE.SALES_ORDER,
  [enumConstants.bank_statement_line_source_types.SALES_RETURN_ORDER]: MODEL_TYPE.SALES_RETURN_ORDER,
  [enumConstants.bank_statement_line_source_types.PURCHASE_INVOICE]: MODEL_TYPE.PURCHASE_INVOICE,
  [enumConstants.bank_statement_line_source_types.PURCHASE_CREDIT_MEMO]: MODEL_TYPE.PURCHASE_CREDIT_MEMO,
  [enumConstants.bank_statement_line_source_types.PURCHASE_FINANCE_CHARGE]: MODEL_TYPE.PURCHASE_FINANCE_CHARGE,
  [enumConstants.bank_statement_line_source_types.PURCHASE_ADVANCE_INVOICE]: MODEL_TYPE.PURCHASE_ADVANCE_INVOICE,
  [enumConstants.bank_statement_line_source_types.PURCHASE_ORDER]: MODEL_TYPE.PURCHASE_ORDER,
  [enumConstants.bank_statement_line_source_types.PURCHASE_RETURN_ORDER]: MODEL_TYPE.PURCHASE_RETURN_ORDER,
  [enumConstants.bank_statement_line_source_types.SERVICE_INVOICE]: MODEL_TYPE.SERVICE_INVOICE,
  [enumConstants.bank_statement_line_source_types.SERVICE_ORDER]: MODEL_TYPE.SERVICE_ORDER
}
